import { put, takeLatest } from 'redux-saga/effects'
import * as Eff from 'redux-saga/effects' // tslint:disable-line:no-duplicate-imports

import Logger from '@Utils/Logger'
import { ISuccessResponse } from '@Root/types'

import {
  fetchThemesSuccess,
  fetchThemesFailure,
} from './actions'

import {
  ThemeActionTypes,
  IFetchThemesSuccessResponseBody,
} from './types'

import * as API from './api'

const call: any = Eff.call

function* fetchThemesSaga() {
  try {
    const response: ISuccessResponse<IFetchThemesSuccessResponseBody> = yield call(API.fetchThemes)
    const payloadResponse = response.data
    yield put(fetchThemesSuccess(payloadResponse))
  } catch (e) {
    Logger.error(e, 'Themes could not be loaded')
    yield put(fetchThemesFailure())
  }
}

function* themeSagas() {
  yield takeLatest(ThemeActionTypes.FETCH_THEMES, fetchThemesSaga)
}

export default themeSagas
